import React, { useState, useEffect } from "react";
import { Container, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Particle from "../Particle";

// Aapki original files
import pdf from "../../Assets/../Assets/ZeeshanResume.pdf"; // Pakistan CV
import pdf1 from "../../Assets/../Assets/Muhammad_Zeeshan_Farooq_CV.pdf"; // International CV

import { AiOutlineDownload } from "react-icons/ai";
import { Document, Page, pdfjs } from "react-pdf";

import "react-pdf/dist/esm/Page/AnnotationLayer.css";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

function ResumeNew() {
  const [width, setWidth] = useState(1200);

  // Default hum pehle 'pdf' (Pakistan) rakh lete hain ya blank, loading state ke sath
  const [resumeLink, setResumeLink] = useState(pdf);

  useEffect(() => {
    // 1. Handle Screen Size
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    handleResize();

    // 2. Automatically Detect Location via IP
    const detectLocation = async () => {
      try {
        // Yeh free API HTTPS par call hogi aur kafi stable hai
        const response = await fetch("https://ipapi.co/json/");
        const data = await response.json();

        console.log("Detected Country Code:", data.country_code); // Aapki debugging ke liye

        // Agar user Pakistan (PK) se hai tou 'pdf', warna 'pdf1'
        if (data.country_code === "PK") {
          setResumeLink(pdf);
        } else {
          setResumeLink(pdf1);
        }
      } catch (error) {
        console.error("Location API failed, checking alternative... ", error);

        // Alternative API try karte hain agar pehli block ho jaye
        try {
          const altResponse = await fetch("https://ip-api.com/json/");
          const altData = await altResponse.json();
          console.log("Alt Detected Country Code:", altData.countryCode);

          if (altData.countryCode === "PK") {
            setResumeLink(pdf);
          } else {
            setResumeLink(pdf1);
          }
        } catch (altError) {
          console.error("Both APIs failed. Defaulting to Pakistan CV.");
          setResumeLink(pdf); // Agar internet issue ya total block ho, tou yahan jo marzi default rakh lein
        }
      }
    };

    detectLocation();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div>
      <Container fluid className="resume-section">
        <Particle />

        {/* Top Download Button */}
        <Row style={{ justifyContent: "center", position: "relative" }}>
          <Button
            variant="primary"
            href={resumeLink}
            target="_blank"
            style={{ maxWidth: "250px" }}
          >
            <AiOutlineDownload />
            &nbsp;Download CV
          </Button>
        </Row>

        {/* PDF Document Preview */}
        <Row className="resume">
          <Document file={resumeLink} className="d-flex justify-content-center">
            <Page pageNumber={1} scale={width > 786 ? 1.7 : 0.6} />
          </Document>
        </Row>

        {/* Bottom Download Button */}
        <Row style={{ justifyContent: "center", position: "relative" }}>
          <Button
            variant="primary"
            href={resumeLink}
            target="_blank"
            style={{ maxWidth: "250px" }}
          >
            <AiOutlineDownload />
            &nbsp;Download CV
          </Button>
        </Row>
      </Container>
    </div>
  );
}

export default ResumeNew;